const DEBUG = false;
const DEV = false;
module.exports = {
  DEBUG,
  DEV
};
